import React from "react";
import styled from "styled-components";

/**
 * The reference's closing legal note: one centred paragraph in a bone band with
 * a hairline rule, sitting between the last section and the footer.
 *
 * Measured off the reference (landing-v1): max-width 896px, 40px vertical
 * padding, 20px horizontal rising to 32px from 640px up, 12px text at 1.625
 * line-height in ink at 60%, and the single link in brand red with no underline.
 *
 * Deliberately has no tone or surface options: it is meant to look identical on
 * all three landers, so the band stays light even on v2 and v3, where it lands
 * between an ink ClosingCta and an ink footer.
 */
const Wrapper = styled.section`
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background: var(--brand-bone);

  .inner {
    margin: 0 auto;
    max-width: 896px;
    padding: 40px 20px;
  }

  p {
    margin: 0;
    text-align: center;
    font-size: 12px;
    line-height: 1.625;
    color: rgba(14, 17, 22, 0.6);
  }

  a {
    color: var(--brand-red);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid var(--brand-red);
      outline-offset: 2px;
    }
  }

  @media screen and (min-width: 640px) {
    .inner {
      padding: 40px 32px;
    }
  }
`;

const Disclaimer = ({
  companyName,
  tribe,
  moreInfoUrl,
}: {
  companyName: string;
  /** e.g. "Otoe-Missouria Tribe" -- named twice in the copy */
  tribe: string;
  /** the sentence is dropped rather than left as dead text when absent */
  moreInfoUrl?: string;
}) => (
  <Wrapper className="section-lp-disclaimer">
    <div className="inner">
      <p>
        {companyName} helps the 40+ million Americans who do not have access to
        short-term credit. These under-served customers deserve an option to
        manage their unforeseen expenses and help get through any difficult
        expenses. Sign your loan agreement and you may get your money in minutes
        via your debit card or same/next business day deposit via ACH. We are
        owned by and operated by the {tribe}.
        {moreInfoUrl ? (
          <>
            {" "}
            For more information about the {tribe}, please{" "}
            <a href={moreInfoUrl} target="_blank" rel="noreferrer">
              click here
            </a>
            .
          </>
        ) : null}
      </p>
    </div>
  </Wrapper>
);

export default Disclaimer;
